export default __webpack_public_path__ + "static/media/Slide24.52ef66f0.jpg";